
import { useAuthStore } from '@/store/modules/auth';
import { App, DirectiveBinding } from 'vue'
export default {
  install(app: App) {
    console.time("directiveInit");
    // console.log("start-init-directive...");
    app.directive("high-light", {
      beforeMount(el: HTMLElement, binding: DirectiveBinding) {
        const searchText = binding.value.toLowerCase();
        const innerHTML = el.innerHTML;
        const regex = new RegExp(`(${searchText})`, 'gi');
        el.innerHTML = innerHTML.replace(regex, '<span style="color:#1e7fff;">$1</span>');
      },
    });
    app.directive("promission", {
      mounted(el: HTMLElement, binding: DirectiveBinding) {
        const code = binding.value;
        const parentEl = el.parentNode
        const authStroe = useAuthStore();
        const permissionList: string[] = authStroe?.userInfo?.codeList || [];
        if (!permissionList.includes(code)) {
          parentEl?.removeChild(el);
        }
      }
    });
    app.directive("throttle", {
      mounted(el: HTMLElement, binding: DirectiveBinding) {

      }
    });
    // console.log("ending-init-directive...");
    console.timeEnd("directiveInit")
  }
}
